<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "SMS Settings",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // Multiselect,
  },
  data() {
    return {
      title: "SMS Settings",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "SMS Settings",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Subject Name",
          sortable: true,
        },
        {
          key: "short",
          label: "Short Name",
          sortable: true,
        },
        {
          key: "class_details.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "sub_type",
          label: "Subject Type",
          sortable: true,
        },
        {
          key: "papers",
          label: "papers",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        amount: "",
      },
      custSms: {
        message: "",
      },
      editdata: {
        name: "",
        short: "",
        id: "",
      },
      nameError: "",
      shortError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("bulksms", [
      "getFeesDefaultSms",
      "SaveStatus",
      "getFeesSMS",
      "getsmsBalance",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllSubjects ? this.AllSubjects.length : 1;
    },
  },
  watch: {
    getFeesDefaultSms(newValue) {
      if (newValue) {
        this.custSms.message = newValue.message;
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllSubjects ? this.AllSubjects.length : 1;
  },
  methods: {
    ...mapActions({
      EditDefaultSMS: "bulksms/editDefaultSMS",
      SubscribeSMS: "bulksms/subscribeSMS",
      FetchSmsBalance: "bulksms/fetchSmsBalance",
      FetchFeesDefaultSMS: "bulksms/fetchFeesDefaultSMS",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllSubjects ? this.AllSubjects.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.data.amount = "";
    },
    customSmsSubmit() {
      this.EditDefaultSMS({
        message: this.custSms.message,
        id: this.getFeesDefaultSms.id,
      });
    },
    subscribeSms() {
      this.SubscribeSMS({
        amount: this.data.amount,
        balance: this.getsmsBalance.length
          ? this.getsmsBalance.deposit - this.getsmsBalance.used
          : 0,
      });
      this.resetError();
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchFeesDefaultSMS();
    this.FetchSmsBalance();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('setting_sms')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body">
              <b-tabs content-class="p-3 text-muted">
                <b-tab active class="border-0">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      ><i class="fa fa-comment" aria-hidden="true"></i> SMS
                      Subscription</span
                    >
                  </template>
                  <div class="row mt-4">
                    <div class="col-9 text-center">
                      <p class="card-title-desc">
                        This is where you can make new subscriptions for
                        Messages (SMS) for your system
                      </p>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div
                      class="col-md-4 text-center"
                      style="border-right: 1px solid #ebe6e6"
                    >
                      <h3 class="card-title text-muted mt-3">
                        Current SMS Balance
                      </h3>
                      <h1
                        class="card-title text-primary mt-3"
                        style="font-size: 30px"
                      >
                        {{
                          getsmsBalance && getsmsBalance.deposit
                            ? getsmsBalance.deposit - getsmsBalance.used
                            : 0
                        }}
                        SMS
                      </h1>
                    </div>
                    <div class="col-md-8 border-right">
                      <form @submit.prevent="subscribeSms" class="ml-2">
                        <div class="form-group col-md-6 col-sm-12 mb-3">
                          <label
                            >Enter Amount
                            <small class="text-primary">(Number of SMS)</small>
                            <small class="text-danger">*</small></label
                          >
                          <div class="input-group">
                            <input
                              type="text"
                              required
                              class="form-control"
                              v-model="data.amount"
                            />
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <button
                            v-b-modal.add-subject-modal
                            class="btn-sm btn btn-primary float-end"
                          >
                            <i class="fa fa-comment" aria-hidden="true"></i>
                            Subscribe
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                      ><i class="fa fa-map" aria-hidden="true"></i> Configure
                      Fees SMS</span
                    >
                  </template>
                  <div class="row mt-4 ml-4 col-md-12 d-flex">
                    <div class="col-md-11 mx-auto mb-2">
                      <p class="card-title-desc">
                        This is where you can customise the message to be sent
                        to parents for fees reminders.
                      </p>
                    </div>

                    <form
                      @submit.prevent="customSmsSubmit"
                      class="col-md-11 mx-auto"
                    >
                      <div class="col-md-12 row">
                        <div
                          class="form-group col-md-6 col-sm-6 mb-3"
                          style="border-right: 1px solid #ebe6e6"
                        >
                          <label>Custom Message</label><br />
                          <span class="text-primary">
                            (Check on the right will be the saved message to the
                            parents for fees reminder.)
                          </span>
                          <textarea
                            v-model="custSms.message"
                            class="form-control mb-3 mt-3"
                            rows="5"
                            required
                            @keypress="resetError()"
                            placeholder="Enter the SMS to parents"
                          ></textarea>
                          <p>
                            <span class="text-success">
                              <b>{{ custSms.message.length + 60 }}</b>
                              Characters | Size:
                              <b
                                >{{
                                  Math.ceil((custSms.message.length + 60) / 159)
                                }}
                                SMS</b
                              >
                            </span>
                            <span class="text-primary ml-2">
                              {{ " " }}(1 SMS = 159 Characters)</span
                            >
                          </p>
                        </div>
                        <div class="form-group col-md-6 col-sm-6 mb-3">
                          <p class="card-title">Message to be saved.</p>
                          <p class="card-title-desc">
                            {{ custSms.message }}
                            Student's Name. Balance: 0 UGX, Level: B1, Year:
                            20__
                          </p>
                        </div>
                      </div>
                      <div class="col-md-12 mt-4">
                        <button
                          v-if="SaveStatus"
                          type="button"
                          disabled
                          class="btn btn-primary btn-sm float-end"
                        >
                          <b-spinner
                            variant="light"
                            small
                            label="Spinning"
                          ></b-spinner>
                          Please Wait...
                        </button>
                        <button
                          v-else
                          type="submit"
                          class="btn-sm btn btn-primary float-end"
                        >
                          <i class="fa fa-check" aria-hidden="true"></i> Save
                          Fees Message
                        </button>
                      </div>
                    </form>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <!-- <b-modal id="add-subject-modal" hide-footer @hidden="resetAddModal()">
        <template #modal-title> Add New Subject </template>
        <div class="row d-flex">
          <div class="form-group col-md-6 mb-3">
            <label>Subject Name <small class="text-danger">*</small></label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Subject Name"
                class="form-control"
                @keyup="checkName"
                @input="resetError"
                v-model="data.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
          <div class="form-group col-md-6 mb-3">
            <label>Short Name <small class="text-danger">*</small></label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Short Name"
                class="form-control"
                @keyup="checkName"
                @input="resetError"
                v-model="data.short"
              />
            </div>
            <div class="text-danger" v-if="shortError">
              <em>{{ shortError }}</em>
            </div>
          </div>
          <div class="form-group col-md-12 mb-3">
            <label>Subject Paper <small class="text-danger">*</small></label>
            <small class="text-primary">(Multiple Select)</small>
            <div class="input-group">
              <multiselect
                v-model="data.subjectpaper"
                :height="300"
                :options="subjectPapers"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                tag-placeholder="Subject Papers"
                placeholder="Select Subject Papers"
                label="name"
                track-by="value"
                :preselect-first="false"
                @input="resetError()"
              >
                <template slot="selection" slot-scope="{ values, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} Subject Papers Selected</span
                  ></template
                >
              </multiselect>
            </div>
          </div>
          <div class="form-group col-md-6 mb-3">
            <label>Select Level <small class="text-danger">*</small></label>
            <div class="input-group">
              <select required v-model="data.level" class="form-control">
                <option selected value="" disabled>Select Level</option>
                <option value="1">O-Level Subject</option>
                <option value="2">A-Level Subject</option>
              </select>
            </div>
          </div>
          <div class="form-group col-md-6 mb-3">
            <label>Subject Type <small class="text-danger">*</small></label>
            <div class="input-group">
              <select required v-model="data.subType" class="form-control">
                <option selected value="" disabled>Select Type</option>
                <option value="1">Compulsory Subject</option>
                <option value="2">Optional Subject</option>
              </select>
            </div>
          </div>
          <div class="form-group col-md-12 mb-2">
            <label
              >Classes <small class="text-danger">*</small> <br />
              <small class="text-primary"
                >(Select classe(s) where subject is to be tought.)</small
              >
            </label>
            <div class="input-group">
              <multiselect
                v-model="data.classes"
                :height="300"
                :options="AllClasses ? AllClasses : []"
                :multiple="true"
                :taggable="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                tag-placeholder="Add a class"
                placeholder="Search or add a class"
                label="name"
                track-by="id"
                :preselect-first="false"
                @input="resetError()"
              >
                <template slot="selection" slot-scope="{ values, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} Classes Selected</span
                  ></template
                >
              </multiselect>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('add-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            disabled
            type="button"
            class="btn-sm btn btn-outline-primary"
            @click="addSubject('add-subject-modal')"
          >
            <b-spinner variant="primary" small label="Spinning"></b-spinner>
            Saving Subject...
          </button>
          <button
            v-else
            type="button"
            class="btn-sm btn btn-outline-primary"
            @click="addSubject('add-subject-modal')"
          >
            <i class="fa fa-check"></i>
            Submit Subject
          </button>
        </div>
      </b-modal> -->
      <!-- modal ends -->
      <!-- edit modal starts -->
      <!-- <b-modal id="edit-subject-modal" hide-footer @hidden="resetEditModal()">
        <template #modal-title> Edit Subject {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Subject Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Short Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="editdata.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('edit-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn-sm btn btn-outline-primary"
            @click="editSubject('edit-subject-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal> -->
      <!-- modal ends -->

      <!-- modal delete subject starts -->
      <!-- <b-modal id="delete-subject-modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <h5 class="text-danger">
            Delete Subject <strong>{{ deletedata.name }}</strong>
          </h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6>
              Do you want to delete Subject,
              <strong>{{ deletedata.name }}</strong
              >?
              <br />
              <br />
              <strong>Click Proceed Button to delete.</strong>
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn-sm btn btn-outline-danger"
            @click="deleteSubject('delete-subject-modal')"
          >
            <i class="fa fa-trash"></i> Procees</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal> -->
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
